module.exports = __webpack_public_path__ + "assets/img/img-number-04.40926178.svg";